/** 是否微信内置浏览器 */
export function isWechatBrowser() {
  return /micromessenger/i.test(navigator.userAgent)
}

/** 是否移动端 */
export function isMobile() {
  return /mobile|android|iphone|ipad|ipod/i.test(navigator.userAgent)
}

/**
 * 判断支付场景
 * jsapi = 微信内浏览器
 * h5    = 手机浏览器（非微信）
 * native = PC 扫码
 */
export function getPayClientType() {
  if (isWechatBrowser()) return 'jsapi'
  if (isMobile()) return 'h5'
  return 'native'
}

/** 调起微信 JSAPI 支付 */
export function invokeWechatJsapi(params) {
  return new Promise((resolve, reject) => {
    function onBridgeReady() {
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        params,
        function (res) {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            resolve(res)
          } else {
            reject(res)
          }
        }
      )
    }
    if (typeof window.WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
      }
    } else {
      onBridgeReady()
    }
  })
}

/** 生成 PC 扫码支付二维码图片地址 */
export function buildWechatQrUrl(codeUrl) {
  return 'https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=' + encodeURIComponent(codeUrl)
}

let pollTimer = null

/** 停止扫码支付轮询 */
export function stopWechatPayPoll() {
  if (pollTimer) {
    clearInterval(pollTimer)
    pollTimer = null
  }
}

/**
 * Native 扫码后轮询支付状态（参考车友会项目）
 */
export function startWechatPayPoll(outTradeNo, options = {}) {
  const {
    onPaid,
    onTimeout,
    intervalMs = 2500,
    maxAttempts = 120
  } = options

  stopWechatPayPoll()
  if (!outTradeNo) {
    return Promise.reject(new Error('订单号无效'))
  }

  let attempts = 0
  return new Promise((resolve, reject) => {
    pollTimer = setInterval(async () => {
      attempts += 1
      try {
        const { queryWechatPayStatus } = await import('@/utils/http')
        const res = await queryWechatPayStatus({ outTradeNo })
        const data = res.data || {}
        if (data.paid || data.status === 1) {
          stopWechatPayPoll()
          if (onPaid) onPaid(data)
          resolve(data)
        } else if (attempts >= maxAttempts) {
          stopWechatPayPoll()
          if (onTimeout) onTimeout()
          reject(new Error('支付超时，请稍后刷新页面查看订单状态'))
        }
      } catch (e) {
        if (attempts >= maxAttempts) {
          stopWechatPayPoll()
          reject(e)
        }
      }
    }, intervalMs)
  })
}

/**
 * 发起微信支付并处理各端回调
 */
export async function startWechatPay(param) {
  const { wechatPay } = await import('@/utils/http')
  const payParam = {
    ...param,
    clientType: param.clientType || getPayClientType()
  }
  const payRes = await wechatPay(payParam)
  const data = payRes.data || {}

  if (data.oauthUrl) {
    window.location.href = data.oauthUrl
    return { status: 'oauth' }
  }
  if (!data.success) {
    throw new Error(data.error || '获取支付信息失败，请稍后重试')
  }
  if (data.payType === 'jsapi' && data.jsapiParams) {
    await invokeWechatJsapi(data.jsapiParams)
    return { status: 'success', outTradeNo: data.outTradeNo }
  }
  if (data.payType === 'h5' && (data.mwebUrl || data.url)) {
    window.location.href = data.mwebUrl || data.url
    return { status: 'redirect', outTradeNo: data.outTradeNo }
  }
  if (data.payType === 'native' && data.codeUrl) {
    return {
      status: 'native',
      codeUrl: data.codeUrl,
      outTradeNo: data.outTradeNo
    }
  }
  throw new Error('暂不支持当前环境的支付方式')
}

/** 统一处理支付异常（含用户取消） */
export function handleWechatPayError(e, onCancel) {
  if (e && e.err_msg && e.err_msg.indexOf('cancel') > -1) {
    if (onCancel) onCancel()
    return true
  }
  if (e && e.message) {
    alert(e.message)
    return true
  }
  alert('支付异常，请稍后重试')
  return true
}
